// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-scrolling-none[data-v-4e106960] {\n  height: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
